import { EntBreedingFarmStatus } from "../../../models/handBooks/breedingFarmStatus";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { Paths } from "../../../paths";

export const breedingFarmStatusApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getBreedingFarmStatusList: builder.query<ResponseDataTest<EntBreedingFarmStatus[]>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.breedingFarmStatuses }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getBreedingFarmStatusById: builder.query<ResponseDataTest<EntBreedingFarmStatus>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.breedingFarmStatuses }/${ id }`,
		method: 'GET'
	  })
	}),
	addBreedingFarmStatus: builder.mutation<ResponseDataTest<EntBreedingFarmStatus>, EntBreedingFarmStatus>({
	  query: (body) => ({
		url: `${ Paths.handbooks.breedingFarmStatuses }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editBreedingFarmStatus: builder.mutation<ResponseDataTest<EntBreedingFarmStatus>, EntBreedingFarmStatus>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.breedingFarmStatuses }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteBreedingFarmStatus: builder.mutation<ResponseDataTest<EntBreedingFarmStatus>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.breedingFarmStatuses }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddBreedingFarmStatusMutation,
  useDeleteBreedingFarmStatusMutation,
  useEditBreedingFarmStatusMutation,
  useLazyGetBreedingFarmStatusListQuery
} = breedingFarmStatusApi;
